module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-event-fill-73c4b562.svg";